(() => {
  const maximum = 250;
  const bound = new WeakSet();
  let sequence = 0;
  let queued = false;
  const candidates = 'textarea, input[type="text"]';
  const isGiftMessage = (field) => {
    if (field.matches('[data-gifting-message], [data-sb="gift-message"]')) return true;
    const name = (field.name || '').replace(/[^a-z]/gi, '').toLowerCase();
    if (name.includes('giftmessage') || name === 'recipientmessage' || name === 'recipientsmessage') return true;
    return [...(field.labels || [])].some(label => /gift\s*message/i.test(label.textContent));
  };
  const attach = (field) => {
    if (bound.has(field) || !isGiftMessage(field)) return;
    bound.add(field);
    field.maxLength = maximum;
    const counter = document.createElement('small');
    counter.id = `orli-gift-count-${++sequence}`;
    counter.className = 'orli-gift-message-count';
    counter.style.cssText = 'display:block;margin:5px 0;font-size:12px;line-height:1.4;color:#756b65';
    counter.setAttribute('aria-live', 'polite');
    const description = field.getAttribute('aria-describedby');
    field.setAttribute('aria-describedby', [description, counter.id].filter(Boolean).join(' '));
    field.insertAdjacentElement('afterend', counter);
    const update = () => {
      if (field.value.length > maximum) field.value = field.value.slice(0, maximum).replace(/[\uD800-\uDBFF]$/, '');
      counter.textContent = `${field.value.length} / ${maximum} characters`;
    };
    field.addEventListener('input', update);
    field.addEventListener('change', update);
    field.form?.addEventListener('reset', () => requestAnimationFrame(update));
    update();
  };
  const scan = () => { queued = false; document.querySelectorAll(candidates).forEach(attach); };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(scan); } };
  scan();
  new MutationObserver(changes => {
    if (changes.some(change => [...change.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(candidates) || node.querySelector?.(candidates))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();
